<template>
  <CustomModal
    v-model:visible="isVisible"
    :title="`Remove from ${featureNames.SEQUENCES}`"
    width="36vw"
    :section-classes="{ 
      overlay: 'bulk_remove_modal_overlay'
    }"
  >
    <div v-if="loadingCount" class="flex items-center gap-2">
      <CustomLoader :size="16" />
      <span>Getting accurate count...</span>
    </div>
    <span v-else>
      Are you sure you want to remove <b>{{ peopleText }}</b> from the {{ featureNames.SEQUENCES }}?
    </span>
    <template #footer>
      <a-button 
        class="primary_medium" 
        @click="handleConfirm"
        :disabled="loadingCount"
      >
        Confirm
      </a-button>
    </template>
  </CustomModal>
</template>

<script setup>
import { computed } from 'vue';
import CustomModal from '@/src/components/CustomModal.vue';
import CustomLoader from '@/src/components/CustomLoader.vue';
import { featureNames } from '@/src/constants/globalConstants';

const props = defineProps({
  visible: {
    type: Boolean,
    default: false
  },
  peopleText: {
    type: String,
    required: true
  },
  loadingCount: {
    type: Boolean,
    default: false
  }
});

const emit = defineEmits(['update:visible', 'confirm']);

const isVisible = computed({
  get: () => props.visible,
  set: (value) => emit('update:visible', value)
});

const handleConfirm = () => {
  emit('confirm');
};
</script>
